query GetMoneyPageTriggers(
    $maUrlId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
) {
    maUrlTriggers(maUrlId: $maUrlId, first: $first, after: $after, last: $last, before: $before) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasPreviousPage
            hasNextPage
        }
        edges {
            cursor
            node {
                triggeredTime
                contact {
                    id
                    name
                    htmlUrlPath
                }
                lead {
                    id
                    name
                    htmlUrlPath
                    assignee {
                        ... on User {
                            id
                            name
                        }
                        ... on Team {
                            id
                            name
                        }
                    }
                }
            }
        }
    }
}
